import { useSelector } from "react-redux";
import {
  PhoneIcon,
  WhatsAppIcon,
  PlaceIcon,
  ShoppingBagOutlinedIcon,
  StorefrontIcon,
} from "../components/icons";
import BottomSheet from "../components/BottomSheet";
import { WHATSAPP_CHAT_URL } from "../ducks/consts";
import useWorkingTime from "../hooks/useWorkingTime";
import WorkingTime from "./WorkingTime";
import toPriceDisplay from "../utils/toPriceDisplay";

/**
 * Contato, endereço, condições do pedido (mínimo da entrega e desconto da
 * retirada) e horários da loja, num painel que sobe do rodapé.
 */
export default function ShopInfoSheet({ show, onHide }) {
  const shop = useSelector((state) => state.shop);
  const { currentWeekDay, rulesDelivery, rulesToGo, rulesInloco } =
    useWorkingTime(shop);
  const whatsappDigits = (shop.whatsapp || "").replace(/\D/g, "");
  // mesa e comanda não têm entrega nem retirada
  const showMinimum =
    !shop.isInLoco && shop.deliveryEnable && shop.deliveryMinimalCost > 0;
  const showTakeoutDiscount =
    !shop.isInLoco && shop.takeoutEnable && shop.takeoutDiscount > 0;

  return (
    <BottomSheet show={show} onHide={onHide} title={shop.name}>
      <ul className="info-list">
        {shop.phone && (
          <li>
            <PhoneIcon className="info-list__icon" />
            <a href={`tel:${shop.phone.replace(/[^\d+]/g, "")}`}>
              {shop.phone}
            </a>
          </li>
        )}
        {whatsappDigits && (
          <li>
            <WhatsAppIcon className="info-list__icon" />
            <a
              href={`${WHATSAPP_CHAT_URL}/55${whatsappDigits}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {shop.whatsapp}
            </a>
          </li>
        )}
        {shop.addressStreet && (
          <li>
            <PlaceIcon className="info-list__icon" />
            <address className="m-0">
              {shop.addressStreet}, {shop.addressNumber}
              {shop.complement ? ", " + shop.complement : ""}
              <br />
              <span className="text-muted">
                {shop.neighborhood}, {shop.city}/{shop.state} - CEP{" "}
                {shop.postalCode}
              </span>
            </address>
          </li>
        )}
        {showMinimum && (
          <li>
            <ShoppingBagOutlinedIcon className="info-list__icon" />
            <span>
              Pedido mínimo para entrega:{" "}
              <strong>{toPriceDisplay(shop.deliveryMinimalCost)}</strong>
            </span>
          </li>
        )}
        {showTakeoutDiscount && (
          <li>
            <StorefrontIcon className="info-list__icon" />
            <span>
              Retirada no balcão com{" "}
              <strong>{shop.takeoutDiscount}% de desconto</strong>
            </span>
          </li>
        )}
      </ul>
      <div className="working-times">
        <WorkingTime
          label="Horário de entrega"
          rules={rulesDelivery}
          currentWeekDay={currentWeekDay}
        />
        <WorkingTime
          label="Horário de retirada"
          rules={rulesToGo}
          currentWeekDay={currentWeekDay}
        />
        <WorkingTime
          label="Horário na mesa"
          rules={rulesInloco}
          currentWeekDay={currentWeekDay}
        />
      </div>
    </BottomSheet>
  );
}
